import { NgModule, ModuleWithProviders } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { reducers } from '@auth/store';
import { AuthEffects } from '@auth/store/effects/auth.effects';
import { SharedModule } from '@shared/shared.module';

import { AuthTokenInterceptor } from './interceptors/auth-token.interceptor';
import { AuthLoginComponent } from './components/auth-login/auth-login.component';
import { AuthApiService } from './services/auth-api.service';
import { RouterModule } from '@angular/router';
import { ROUTES } from './auth.routes';
import { AuthTwoFactorsCodeComponent } from './components/auth-two-factors-code/auth-two-factors-code.component';

@NgModule({
  declarations: [AuthLoginComponent, AuthTwoFactorsCodeComponent],
  imports: [
    CommonModule,
    StoreModule.forFeature('auth', reducers),
    EffectsModule.forFeature([AuthEffects]),
    SharedModule,
    FormsModule,
    MatFormFieldModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatInputModule,
    MatButtonModule,
    RouterModule.forChild(ROUTES),
  ],
})
export class AuthModule {
  static forRoot(): ModuleWithProviders<AuthModule> {
    return {
      ngModule: AuthModule,
      providers: [
        {
          provide: HTTP_INTERCEPTORS,
          useClass: AuthTokenInterceptor,
          multi: true,
        },
        AuthApiService,
      ],
    };
  }
}
